import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { FileUpload } from '../../fileupload';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { UploadFileService } from '../../upload-file.service';
import { LoggingService } from 'src/app/shared/services/Logging.service';
@Component({
  selector: 'app-form-upload-video',
  templateUrl: './form-upload-video.component.html',
  styleUrls: ['./form-upload-video.component.css'],
  inputs: ['idBot', 'uploadvideoPath', 'videolink', 'editMode']
})
export class FormUploadVideoComponent implements OnInit {
  selectedVideo!: FileList | undefined;
  currentFileUpload!: FileUpload;
  progress: { percentage: number } = { percentage: 0 };
  botImageURL!: boolean;
  download!: boolean;
  downloadURL: any;
  uploadvideoPath;
  link: any;
  image;
  videolink: any;
  idBot;
  editMode;
  showURL = false
  @Output() urlVideoCard = new EventEmitter();
  @Output() showURLvideoInput = new EventEmitter();
  src!: string;

  isUploading: boolean = false;

  constructor(private loggingService: LoggingService, private uploadService: UploadFileService,
    private storage: AngularFireStorage,
  ) { }

  ngOnInit() {

  }
  URLVideoInput() {
    this.showURL = !this.showURL
    this.showURLvideoInput.emit(this.showURL);
  }
  selectFile(event) {
    this.selectedVideo = event.target.files;
    setTimeout(() => { this.upload() }, 1000);

  }

  upload() {
    const file = this.selectedVideo?.item(0);
    this.selectedVideo = undefined;
    if (file != undefined)
      this.currentFileUpload = new FileUpload(file);

    this.botImageURL = false;
    this.download = true;
    this.isUploading = true;
    const filePath = this.uploadvideoPath;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.percentageChanges().subscribe(percentage => {
      this.progress.percentage = Math.round(percentage ? percentage : 0);
    });

    task.snapshotChanges().pipe(
      finalize(() => {
        this.downloadURL = fileRef.getDownloadURL();
        this.isUploading = false;
      })
    )
      .subscribe(image => {
        this.loggingService.log('image', image)
        this.link = fileRef.getDownloadURL().subscribe(tt => {
          this.videolink = tt;
          if (this.videolink)
            this.loggingService.log(this.videolink)
          this.urlVideoCard.emit(this.videolink);
        });
      })
  }
}
